import { AppConsts } from './enums/AppConsts';
import { ApolloClient, InMemoryCache, split } from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { setContext } from '@apollo/client/link/context';
import { getMainDefinition } from '@apollo/client/utilities';
import { createUploadLink } from 'apollo-upload-client';

let httpLink;
if (process.env.NODE_ENV === 'test') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const dotenv = require('dotenv');
  dotenv.config();
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const fetch = require('node-fetch');
  httpLink = createUploadLink({
    fetch: fetch as any,
    uri: 'https://crm-backend.epra.com/'
  });
} else {
  httpLink = createUploadLink({
    uri: 'https://crm-backend.epra.com/'
  });
}

const wsLink = new WebSocketLink(
  new SubscriptionClient('wss://crm-backend.epra.com/graphql', {
    reconnect: true,
    connectionParams: () => {
      const token = localStorage.getItem(AppConsts.AccessToken);
      return {
        authToken: token
      };
    }
  })
);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem(AppConsts.AccessToken);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ?? ''
    }
  };
});

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  authLink.concat(httpLink)
);

const cache = new InMemoryCache({
  addTypename: true
});

const client = new ApolloClient({
  cache,
  link
});

export default client;
